// extracted by mini-css-extract-plugin
module.exports = {"item":"AllowedRoutesSkeleton_item__1JXyp","root":"AllowedRoutesSkeleton_root__1EgV2","rect":"AllowedRoutesSkeleton_rect__3XwsE","text":"AllowedRoutesSkeleton_text__1SMnZ"};